// extracted by mini-css-extract-plugin
export default {"viewDetailsButton":"viewDetailsButton---_4EYy"};